export default function WorksCited({ children }) {
    return (
        <div className="indent-4 my-4">
            <hr />
            <h2 className="text-center font-bold text-2xl mt-3 mb-2">Works Cited</h2>
            {children}
        </div>
    )
}